export default {"src":"/_next/static/media/vpro.114c28f5.svg","height":49,"width":159,"blurWidth":0,"blurHeight":0};